const auth_status = {
    page_title: '認証ステータス',
    title: '認証ステータス',
    description: '認証のステータスを確認してください。',
};
export default Object.freeze(auth_status);
